import { SuperbetRouteConfig } from '@superbet-group/web.types';
import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import PhoneVerificationCaptive from './PhoneVerificationCaptive.vue';

export const phoneVerificationCaptiveRoute: SuperbetRouteConfig = {
    path: Link.App.VerifyPhoneCaptive || '/verify-phone',
    name: RouteName.App.VerifyPhoneCaptive,
    components: {
        content: PhoneVerificationCaptive,
    },
    meta: {
        isBehindLogin: false,
        layoutClass: 'captive-kyc-page',
    },
};
